const comments = [
  {
    name: '追剧小王子',
    text: '之前在其他平台看剧总卡，换了爱豆影视之后简直起飞！高清流畅不缓冲是真的，繁花沪语版画质绝了，强烈推荐！',
    time: '2小时前',
    show: '繁花',
  },
  {
    name: '电影控阿飞',
    text: '流浪地球3的4K版在这里看到的，画质和音效都超棒。资源更新也快，新片基本上隔天就能看，已经安利给身边所有人了。',
    time: '5小时前',
    show: '流浪地球3',
  },
  {
    name: '悬疑爱好者',
    text: '国产悬疑剧迷狂喜！从隐秘的角落到漫长的季节，想看的全都有。而且真的没有广告弹窗，观影体验太纯粹了。',
    time: '1天前',
    show: '漫长的季节',
  },
  {
    name: '动漫宅小圆',
    text: '动漫专区的番剧太全了，连一些冷门老番都能找到。清晰度和字幕质量都很能打，二次元的快乐老家没跑了。',
    time: '1天前',
    show: '动漫专区',
  },
  {
    name: '带娃宝妈咪',
    text: '暑假给孩子找动画片发现的这个站，少儿内容分类很清晰，画质好没有乱七八糟的广告，小朋友自己操作也很安全放心。',
    time: '2天前',
    show: '少儿专区',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">观众热评</h2>
          <p className="text-sm text-foreground-500">来自真实用户的使用反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary-300 to-accent-400 flex items-center justify-center text-background-50 text-sm font-bold flex-shrink-0">
                  {comment.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs">
                      在看《{comment.show}》
                    </span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                    <span className="text-xs text-foreground-400 ml-1.5">{comment.time}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}